import httpClient, { catchError } from '@emmacare/common/api/httpClient'

import { setQuickMessagesManagementList } from 'src/store/modules/admin'

import {
  QUICK_MESSAGES_MANAGEMENT_DELETE_MESSAGE,
  QUICK_MESSAGES_MANAGEMENT_GET_LIST,
  QUICK_MESSAGES_MANAGEMENT_PATCH_DELETE_ITEM,
  QUICK_MESSAGES_MANAGEMENT_POST_ITEM,
  QUICK_MESSAGES_MANAGEMENT_SAVE_MESSAGE,
  QUICK_MESSAGES_MANAGEMENT_UPDATE_MESSAGE,
  QUICK_MESSAGES_MANAGEMENT_UPDATE_ORDER_NUMBER,
  QUICK_MESSAGES_POST_MESSAGE,
  QUICK_MESSAGES_SEND_MESSAGE
} from 'src/constants'
import { showSuccessModal } from 'src/services/dialogs'

export const getQuickMessages = async (config = {}) => {
  const { query = {} } = config

  try {
    const { items = [] } = await httpClient.request({
      method: 'get',
      url: {
        pathname: QUICK_MESSAGES_MANAGEMENT_GET_LIST,
        query
      }
    })

    return items
  } catch (err) {
    catchError(err)

    return []
  }
}

export const fetchQuickMessagesManagementList =
  (config = {}) =>
  async (dispatch) => {
    try {
      const items = await getQuickMessages(config)

      dispatch(setQuickMessagesManagementList(items))
    } catch (err) {
      catchError(err)
    }
  }

export const saveQuickMessagesManagement =
  (config = {}) =>
  async () => {
    try {
      await httpClient.request({
        method: 'post',
        url: {
          pathname: QUICK_MESSAGES_MANAGEMENT_POST_ITEM
        },
        ...config
      })

      showSuccessModal({
        content: QUICK_MESSAGES_MANAGEMENT_SAVE_MESSAGE,
        centered: true,
        keyboard: false
      })

      return true
    } catch (err) {
      catchError(err)

      return false
    }
  }

export const updateQuickMessagesManagement =
  (config = {}) =>
  async () => {
    const { payload = {}, params = {} } = config

    try {
      await httpClient.request({
        method: 'patch',
        url: {
          pathname: QUICK_MESSAGES_MANAGEMENT_PATCH_DELETE_ITEM,
          params
        },
        payload
      })

      showSuccessModal({
        content: QUICK_MESSAGES_MANAGEMENT_UPDATE_MESSAGE,
        centered: true,
        keyboard: false
      })

      return true
    } catch (err) {
      catchError(err)

      return false
    }
  }

export const deleteQuickMessagesManagement =
  (config = {}) =>
  async () => {
    const { payload = {}, params = {} } = config

    try {
      await httpClient.request({
        method: 'delete',
        url: {
          pathname: QUICK_MESSAGES_MANAGEMENT_PATCH_DELETE_ITEM,
          params
        },
        payload
      })

      showSuccessModal({
        content: QUICK_MESSAGES_MANAGEMENT_DELETE_MESSAGE,
        centered: true,
        keyboard: false
      })

      return true
    } catch (err) {
      catchError(err)

      return false
    }
  }

export const updateQuickMessagesOrderNumber =
  (config = {}) =>
  async () => {
    const { payload = {}, params = {} } = config

    try {
      await httpClient.request({
        method: 'patch',
        url: {
          pathname: QUICK_MESSAGES_MANAGEMENT_UPDATE_ORDER_NUMBER,
          params
        },
        payload
      })

      showSuccessModal({
        content: QUICK_MESSAGES_MANAGEMENT_UPDATE_MESSAGE,
        centered: true,
        keyboard: false
      })

      return true
    } catch (err) {
      catchError(err)

      return false
    }
  }

export const sendQuickMessage =
  (config = {}) =>
  async () => {
    const { payload = {}, params = {} } = config

    try {
      await httpClient.request({
        method: 'post',
        url: {
          pathname: QUICK_MESSAGES_POST_MESSAGE,
          params
        },
        payload
      })

      showSuccessModal({
        content: QUICK_MESSAGES_SEND_MESSAGE,
        centered: true,
        keyboard: false
      })

      return true
    } catch (err) {
      catchError(err)

      return false
    }
  }
